
//查询计算任务中已完成计算的元件
export const buildRunNodes = (nodeDataArray) => 
{
    let runNodes = {};

    if(nodeDataArray)
    {
        for(let i=0;i<nodeDataArray.length;i++)
        {
            let nodeData = nodeDataArray[i];
            let nodeKey = nodeData.key;
            let nodeName = nodeData.nodeName;
            let nodeIsRun = nodeData.isRun;

            if(nodeIsRun)
            {
                let runNode = 
                {
                    key:nodeKey,
                    name:nodeName,
                };
                runNodes[nodeKey] = runNode;
            }
        }
    }

    return runNodes;
};
